var COOKIE = 'IMMOPRO';
var COOKIE_FORCE = false;
var COOKIE_VERSION = '001';
var COOKIE_DEBUG = false;
var COOKIE_DAYS = window.kirbyConfig.cookieDuration || 7;
var LANGUAGE_COOKIE = 'IMMOPRO_LANG';
var DEFAULT_LANGUAGE = 'fr';

// Facebook Pixel initialization
function initFacebookPixel() {
    !function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
            n.callMethod ?
                n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', `${window.kirbyConfig.fbPixelKey}`);
    fbq('track', 'PageView');
}

function agSetCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = 'expires=' + d.toUTCString();
    var cookie = cname + '=' + cvalue + ';' + expires + ';path=/;Secure;SameSite=None;Partitioned';
    document.cookie = cookie;
    if (COOKIE_DEBUG) console.log('[CR] We set this cookie: ' + cookie);
}

function agGetCookie(cname) {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}

function agClearCookies() {
    var cookies = document.cookie.split(";");

    // Clear cookies from the root path
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        var expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
        document.cookie = name + '=;expires=' + expires + ';path=/;Secure;SameSite=None;Partitioned';
        if (COOKIE_DEBUG) console.log('[CR] Clearing cookie: ' + name + ' from root path');
    }

    // Clear third-party cookies
    clearThirdPartyCookies(['open.spotify.com', '.cadax.ca', '.wibo.ca']);
    // Clear local storage
    localStorage.clear();
    if (COOKIE_DEBUG) console.log('[CR] Local storage cleared');

    // Clear session storage
    sessionStorage.clear();
    if (COOKIE_DEBUG) console.log('[CR] Session storage cleared');
}

function clearThirdPartyCookies(domains) {
    domains.forEach(domain => {
        var cookies = document.cookie.split(";");
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            var eqPos = cookie.indexOf("=");
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            var expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
            document.cookie = name + '=;expires=' + expires + ';path=/;domain=' + domain + ';Secure;SameSite=None;Partitioned';
            if (COOKIE_DEBUG) console.log('[CR] Clearing third-party cookie: ' + name + ' from domain ' + domain);
        }
    });
}


function agCheckCookie() {
    var cookie = agGetCookie(COOKIE);
    if (COOKIE_DEBUG) console.log('[CR] We found this cookie: ' + cookie);
    return cookie;
}

function setLanguagePreference() {
    var languageCookie = agGetCookie(LANGUAGE_COOKIE);
    if (!languageCookie && window.allowCookies) {
        var path = window.location.pathname;
        var language = path.startsWith('/en') ? 'en' : DEFAULT_LANGUAGE;
        agSetCookie(LANGUAGE_COOKIE, language, COOKIE_DAYS);
        return language;
    }

    return languageCookie;
}

function redirectToLanguage(language) {
    var currentPath = window.location.pathname;
    var newPath;

    // Remove existing language prefix if it exists
    currentPath = currentPath.replace(/^\/(en|fr)/, '');

    // Add new language prefix
    if (language === 'en') {
        newPath = '/en' + (currentPath || '/');
    } else {
        newPath = currentPath || '/';
    }

    if (window.location.pathname !== newPath) {
        window.location.href = newPath;
    }
}

$(function () {
    if (COOKIE_DEBUG) {
        console.log('Cookie Ribbon (CR) Settings');
        console.log('* COOKIE = ' + COOKIE);
        console.log('* COOKIE_FORCE = ' + COOKIE_FORCE);
        console.log('* COOKIE_VERSION = ' + COOKIE_VERSION);
        console.log('* COOKIE_DEBUG = ' + COOKIE_DEBUG);
        console.log('* COOKIE_DAYS = ' + COOKIE_DAYS);
    }

    var v = 'ok-version-' + COOKIE_VERSION;

    // Force display
    if (COOKIE_FORCE) {
        if (COOKIE_DEBUG) console.log('[CR] Forcing display');
        agSetCookie(COOKIE, '', COOKIE_DAYS);
    }

    if (agCheckCookie() != v) {
        window.allowCookies = false;
        setTimeout(function () {
            if (COOKIE_DEBUG) console.log('[CR] Displaying ribbon');
            $('#ribbon').css('display', 'flex').hide().fadeIn();
        }, 1500);
    }

    if (agCheckCookie() == v) {
        window.allowCookies = true;
        // set language preference
        setLanguagePreference();
        $('#ribbon').css('display', 'none');
    }

    var currentLanguage = setLanguagePreference();

    // Add language switcher click handler
    $('.header__languages-item').click(function (e) {
        e.preventDefault();
        if (window.allowCookies) {
            var newLanguage = $(this).attr('hreflang');
            agSetCookie(LANGUAGE_COOKIE, newLanguage, COOKIE_DAYS);
            redirectToLanguage(newLanguage);
        }
    });

    if (!window.location.pathname.includes('/en') && currentLanguage === 'en') {
        redirectToLanguage('en');
    } else if (window.location.pathname.includes('/en') && currentLanguage === 'fr') {
        redirectToLanguage('fr');
    }

    $('#ribbon-submit').click(function (e) {
        e.preventDefault();

        $('#ribbon').fadeOut();
        agSetCookie(COOKIE, v, COOKIE_DAYS);
        agSetCookie('allowCookies', 'true', COOKIE_DAYS);
        window.allowCookies = true;
        initGoogleTagManager();
        initFacebookPixel();
        window.location.reload();
    });

    $('#ribbon-refuse').click(function (e) {
        e.preventDefault();
        window.allowCookies = false;
        agClearCookies();
        $('#ribbon').fadeOut();
    });
});

function initGoogleTagManager() {
    // Create the Google Tag Manager script element
    var script = document.createElement('script');
    script.async = true;
    if (window.kirbyConfig && window.kirbyConfig.tagManagerKey) {
        (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({
                'gtm.start': new Date().getTime(),
                event: 'gtm.js'
            });
            var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s),
                dl = l != 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.src =
                'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', '<?= $site->gtm_id() ?>');

    }
}

function agSetAgeCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = 'expires=' + d.toUTCString();
    var s = cname + '=' + cvalue + ';' + expires + ';path=/;Secure;SameSite=None;Partitioned';
    document.cookie = s;
    if (COOKIE_DEBUG) console.log('[CR] We set this age cookie: ' + s);
}


function agGetAgeCookie(cname) {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}

function agCheckAgeCookie() {
    var cookie = agGetAgeCookie('wibo-age-gate');
    //console.log('\\_ We have this cookie: ' + cookie);
    return cookie;
}

function agCalcAge(dateString) {
    var birthday = +new Date(dateString);
    return ~~((Date.now() - birthday) / (31557600000));
}

// Age Gate
$(function () {
    if ($('#ag-submit').length > 0) {
        $('#ag-submit').click(function () {
            if (window.allowCookies == true) {
                var d = $('#ag-date').val();
                var p = $('#ag-prov').val();
                if (d == '') {
                    alert('Veuillez spécifier votre date de naissance');
                }
                else if (p == '') {
                    alert('Veuillez spécifier votre province');
                }
                else {
                    var age = agCalcAge(d);
                    if (age < 21) {
                        alert('Vous devez être âgé de 21 ans ou plus pour accéder à ce contenu');
                    }
                    else {
                        agSetAgeCookie('wibo-age-gate', 'ok', 7);
                        $('#ag-overlay').fadeOut();
                        window.location.reload();
                    }
                }
            } else {
                alert('Vous devez accepter les cookies pour accéder à ce contenu');
            }
        });

        if (agCheckAgeCookie() != 'ok') {
            $('#ag-overlay').css({
                'position': 'fixed',
                'top': '0',
                'left': '0',
                'width': '100%',
                'height': '100%',
                'z-index': '9999',
                'background-color': 'rgba(0,0,0,0.8)',
                'display': 'flex',
                'justify-content': 'center',
                'align-items': 'center'
            }).show();
            $('body').css('overflow', 'hidden');
            history.pushState(null, null, location.href);
            window.onpopstate = function () {
                history.go(1);
            };
        }
    }
});




/* eof */
